import VueCountdown from '@chenfengyuan/vue-countdown'
import CKEditor from '@ckeditor/ckeditor5-vue'
import ColorPicker from '@oysterlee/vue-color-picker'
import Datepicker1 from '@vuepic/vue-datepicker'
import '@vuepic/vue-datepicker/dist/main.css'
import 'bootstrap/dist/js/bootstrap.bundle.min.js'
import { vMaska } from 'maska'
import { createPinia } from 'pinia'
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'
import simplebar from 'simplebar-vue'
import 'simplebar/dist/simplebar.min.css'
import 'sweetalert2/dist/sweetalert2.min.css'
import 'tailwindcss'
import { createApp } from 'vue'
import Lightbox from 'vue-easy-lightbox'
import VueGoodTablePlugin from 'vue-good-table-next'
import 'vue-good-table-next/dist/vue-good-table-next.css'
import Vue3Autocounter from 'vue3-autocounter'
import Vue3ColorPicker from 'vue3-colorpicker'
import 'vue3-colorpicker/style.css'
import Vue3EasyDataTable from 'vue3-easy-data-table'
import 'vue3-easy-data-table/dist/style.css'
import VueHighlightJS from 'vue3-highlightjs'
import 'vue3-highlightjs/styles/solarized-light.css'
import App from './App.vue'
import './assets/scss/custom/_proforma.scss'
import router from './router/'
import './style.scss'
// import jsVectorMap from 'jsvectormap';
// import 'jsvectormap/dist/maps/world-merc.js';
// import 'jsvectormap/dist/maps/world.js';
// import 'jsvectormap/dist/css/jsvectormap.css';
import '@/assets/icon-fonts/bootstrap-icons/icons/font/bootstrap-icons.css'
import ClickOutside from '@/core/directives/ClickOutsideDirective'
import { i18n } from '@/plugins/i18n/index.js'
import * as Sentry from '@sentry/vue'
import 'dayjs/locale/en'
import 'dayjs/locale/es'
import { LoadingPlugin } from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/css/index.css'
import Vue3Toasity from 'vue3-toastify'
import 'vue3-toastify/dist/index.css'

// #SweetAlert2
import 'sweetalert2/dist/sweetalert2.min.css'
import VueSweetalert2 from 'vue-sweetalert2'

import VueAppleLogin from 'vue-apple-login'

const app = createApp(App).component('vue3-autocounter', Vue3Autocounter)
app.component(VueCountdown.name, VueCountdown)
const pinia = createPinia()
pinia.use(piniaPluginPersistedstate)
app.use(ColorPicker)
app.use(VueHighlightJS)
app.use(CKEditor)
app.directive('maska', vMaska)
app.component('Simplebar', simplebar)
app.component('EasyDataTable', Vue3EasyDataTable)
app.use(router)
app.use(Vue3ColorPicker)
app.component('Datepicker1', Datepicker1)
app.use(pinia)
app.use(Lightbox)
// app.component("jsVectorMap", jsVectorMap);
app.use(VueGoodTablePlugin)
app.use(i18n)
app.use(Vue3Toasity, {
  autoClose: 5000
})
app.use(LoadingPlugin)
app.directive('click-outside', ClickOutside)
app.use(VueSweetalert2)

function generateNonce(length) {
  const charset = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
  let nonce = ''
  for (let i = 0; i < length; i++) {
    const randomIndex = Math.floor(Math.random() * charset.length)
    nonce += charset[randomIndex]
  }
  return nonce
}
const nonce = generateNonce(16)

if (import.meta.env.VITE_MODE !== 'development')
  Sentry.init({
    app,
    dsn: 'https://d579d61a14833f50683d868061aeff64@o4508660306673664.ingest.us.sentry.io/4508698968326144',
    integrations: []
  })

app.use(VueAppleLogin, {
  clientId: 'cl.copecflux.login',
  scope: 'name email',
  redirectURI: 'https://devlink.copecflux.cl',
  state: Date.now().toString(),
  usePopup: true,
  nonce: nonce
})

app.mount('#app')
